  <form [formGroup]="accountTypeForm">
    <div class="flex align-items-start mb-4">
      <p-button label="Save" class="p-button-outlined ml-2" icon="pi pi-save" size="small" (click)="createAccountGroup()"></p-button>
    </div>

    <div class="formgrid grid">

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="accountSubGroupCode" class="label-required display">Account SubGroup Code</label>
          <div class="flex align-items-center">
            <input 
              type="text" 
              pInputText 
              placeholder="e.g AG89098" 
              (blur)="checkAccountTypeCode()" 
              class="w-full"
              formControlName="AccountSubGroupCode" 
              [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountSubGroupCode.errors}" />
            <div class="ml-3">
              <p-checkbox 
                formControlName="manualEntry" 
                (onChange)="manualEntry()" 
                [binary]="true" 
                label="Manual Entry" 
                value="true"></p-checkbox>
            </div>
          </div>
          <small *ngIf="submitted && formControls.AccountSubGroupCode.errors" class="text-red-500">Required field.</small>
        </div>
      </div>

      <!-- Account Group Field -->
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="accountGroupCode" class="label-required display">Account Group</label>
          <p-autoComplete 
            formControlName="accountGroupCode"
            (onSelect)="setAccountGroup($event)"
            [dropdown]="true"
            [suggestions]="filterAG"
            (completeMethod)="filterAGs($event)"
            field="accountGroupCode"
            placeholder="Search account groups"
            class="w-full mb-3"
            styleClass="w-full mb-3"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.accountGroupCode.errors}">
            <ng-template let-item pTemplate="item">
              <span><span class="text-primary">{{item.accountGroupCode}}</span> - {{item.accountGroupName}}</span>
            </ng-template>
          </p-autoComplete>
          <small *ngIf="submitted && formControls.accountGroupCode.errors" class="text-red-500" style="margin-top: -10px; display: block;">Required field.</small> 
        </div>
      </div>

    </div>

    <!-- Account SubGroup Type Name & Description Fields -->
    <div class="row">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="accountSubGroupName" class="label-required display">Account SubGroup Name</label> 
          <input pInputText 
            placeholder="e.g Tom Hank"
            formControlName="AccountSubGroupName"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountSubGroupName.errors}" />
          <small *ngIf="submitted && formControls.AccountSubGroupName.errors" class="text-red-500">Required field.</small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="accountSubGroupDescription">Account SubGroup Description</label>
          <input pInputText 
            formControlName="AccountSubGroupDescription" />
        </div>
      </div>
    </div>

  </form>

